export class Vendorregistration {
    vendorname: string;
    scurl: string;
    sturl: string;
    sqfurl: string;
    sqcrurl: string;
    language:string;
    country:string;
    typesingle:string;
    typemultiple:string;
    vendorclip:string;
    VendCompRedirectURL:string;
    VendTermRedirectURL:string;
    VendQFRedirectURL:string;
    VendQCRRedirectURL:string;
    ipsecurity:boolean;
    custompage:boolean;
    geoiplocation:boolean;
    fingerprintsecurity:boolean;
    single:string;
    multiple:string;
    unassignsurveylink:number;
    assignlink: number;
}
